export default "__VITE_ASSET__BImBNCqH__"